import React from 'react';
import { Select } from '@insurancemenu/imenu-components-lib/dist/components';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';

export interface SponsorSelectProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
}

const SponsorSelect = observer(({ value, onChange, className = '' }: SponsorSelectProps): JSX.Element => {
  const {
    uploadSyncFilesStore: { getSponsorOptions },
  } = useRootStore();

  return (
    <Select
      label="Sponsor Id"
      name="sponsorId"
      options={getSponsorOptions()}
      onChange={onChange}
      value={value}
      width="23rem"
      validationPassed={!!value}
      validationMessage="Please select sponsor"
      className={className}
    />
  );
});

export default SponsorSelect;
